import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { REFERRAL_COLUMN_PALETTE } from "@/referrals/constants";
import { ReferralColumn as ReferralColumnType } from "@/referrals/referral";

interface NumberOfReferralsProps {
  count: number;
  column: ReferralColumnType;
  isLoading?: boolean;
}

const NumberOfReferrals = ({
  count,
  column,
  isLoading,
}: NumberOfReferralsProps) =>
  isLoading ? (
    <Skeleton className="h-6 w-6 rounded-full" />
  ) : (
    <Text
      variant="caption"
      className={cn(
        "inline-flex h-6 min-w-6 items-center justify-center rounded-full px-1.5 font-medium tabular-nums",
        REFERRAL_COLUMN_PALETTE[column].surface,
        REFERRAL_COLUMN_PALETTE[column].foreground,
      )}
    >
      {count}
    </Text>
  );

export default NumberOfReferrals;
